<form class="lp-two-fa-form" [formRoot]="codeForm">
  @if (isForAdmin()) {
    <h1 i18n="@@auth.twoFa.titelDu" class="dm-margin-bottom-12 dm-text-display-xs desktop:dm-text-display-sm dm-text-weight-semibold">
      Überprüfe dein E-Mail-Postfach
    </h1>
    <p i18n="@@auth.twoFa.codeGesendetDu" class="dm-text-md dm-margin-bottom-32">Wir haben einen Code an deine E-Mail-Adresse gesendet.</p>
  } @else {
    <h1 i18n="@@auth.twoFa.titelSie" class="dm-margin-bottom-12 dm-text-display-xs desktop:dm-text-display-sm dm-text-weight-semibold">
      Überprüfen Sie Ihr E-Mail-Postfach
    </h1>
    <p i18n="@@auth.twoFa.codeGesendetSie" class="dm-text-md dm-margin-bottom-32">Wir haben einen Code an Ihre E-Mail-Adresse gesendet.</p>
  }

  <lp-form-alert [message]="alertMessage()" [variant]="alertVariant()" [icon]="alertIcon()" />

  <!-- `placeholder` is the single character shown in an empty slot, so it is left at its
       default; the field is named for assistive tech through `inputLabel` instead. -->
  <dm-pin-input
    [autoSubmit]="false"
    [length]="OTP_LENGTH"
    i18n-inputLabel="@@auth.twoFa.codeEingeben"
    inputLabel="Code eingeben"
    [formField]="codeForm.otp"
    [errormsg]="otpErrorMessage()"
  />

  <div class="dm-margin-top-24">
    <dm-checkbox i18n-label="@@auth.twoFa.geraetVertrauen" label="Diesem Gerät 7 Tage vertrauen" [formField]="codeForm.angemeldetBleiben" />
  </div>

  <div class="dm-margin-top-32">
    <dm-button
      [dmType]="'submit'"
      [isLoading]="loadingStatus() === 'loading'"
      [grow]="true"
      [disabled]="codeForm().invalid() || codeForm.otp().value().length < OTP_LENGTH"
      i18n="@@auth.twoFa.verifizieren"
      >Verifizieren
    </dm-button>
  </div>

  <div class="dm-margin-top-32">
    @if (isForAdmin()) {
      <p i18n="@@auth.twoFa.keineEmailDu" class="dm-text-sm dm-text-align-center">
        Hast du keine E-Mail erhalten?
        <dm-button color="link-color" (click)="sendOtpAgain()">Erneut senden</dm-button>
      </p>
    } @else {
      <p i18n="@@auth.twoFa.keineEmailSie" class="dm-text-sm dm-text-align-center">
        Haben Sie keine E-Mail erhalten?
        <dm-button color="link-color" (click)="sendOtpAgain()">Erneut senden</dm-button>
      </p>
    }
  </div>

  <div class="dm-margin-top-32">
    <p i18n="@@auth.zurueckZumLogin" class="dm-text-sm dm-text-align-center"><a [routerLink]="loginRoute">Zurück zum Login</a></p>
  </div>
</form>
